module.exports = __webpack_public_path__ + "a627276adba1cd2d9ddd5346f72d27c1.pdf";